module.exports = __webpack_public_path__ + "static/media/background-career-1.19a4468d.svg";